import request from "@/utils/request";
const index = {
  // 新增
  uploadImg(data) {
    return request({
      url: "/upload/base64",
      method: "post",
      data
    });
  },
};
export default index;
